import {size} from 'lodash'
import {Basic, Ventrata} from 'types'

export const getOrderActivityDetails = (order: Ventrata.Order): Basic.OrderActivityDetails => {
  const orderActivityDetails: Basic.OrderActivityDetails = {}

  for (const booking of order.bookings) {
    const bookingActivityDetails: Basic.BookingActivityDetails = {}

    for (const unitItem of booking.unitItems) {
      if (unitItem.unit.questions && unitItem.unit.questions.length > 0) {
        const travelerACtivityDetails: Basic.TravelerActivityDetails = {}

        for (const question of unitItem.unit.questions) {
          const questionAnswer = unitItem.questionAnswers?.find((answer) => answer.questionId === question.id)
          travelerACtivityDetails[question.id] = questionAnswer ? questionAnswer.value || '' : ''
        }

        bookingActivityDetails[unitItem.id] = travelerACtivityDetails
      }

      if (size(bookingActivityDetails) > 0) {
        orderActivityDetails[booking.uuid] = bookingActivityDetails
      }
    }
  }

  return orderActivityDetails
}
